import React from 'react'
import { Container, ContainerInterno, ColSm6, TagBonus, TituloPrincipal, TextoPrincipal, ListaConteudos, ListaConteudosItem, ListaConteudosItemIndex, ListaConteudosItemTextos, ListaConteudosItemTextosTitulo, ListaConteudosItemTextosTexto } from './Styled'

export default function ProgramaDeMentorias () {

	return (
		<Container>
			<ContainerInterno>

				{/* Box Esquerda */}
				<ColSm6>

					{/* Tag Bônus */}
					<TagBonus>BÔNUS EXCLUSIVO</TagBonus>

					{/* Título */}
					<TituloPrincipal>Programa de Mentoria<br /> Estratégica <strong>incluso no seu<br /> plano Premium</strong></TituloPrincipal>

					{/* Texto */}
					<TextoPrincipal>Um acompanhamento que normalmente custa <strong>cerca de R$ 900 por 2<br /> meses</strong> — e que aqui você leva de graça ao renovar sua assinatura<br /> Premium.</TextoPrincipal>

				</ColSm6>

				{/* Box Direita */}
				<ColSm6>

					{/* Lista */}
					<ListaConteudos>

						{/* Item 1 */}
						<ListaConteudosItem>
							<ListaConteudosItemIndex>1</ListaConteudosItemIndex>
							<ListaConteudosItemTextos>
								<ListaConteudosItemTextosTitulo>Teste vocacional</ListaConteudosItemTextosTitulo>
								<ListaConteudosItemTextosTexto>Descobrimos a área de concurso que mais combina com o seu perfil.</ListaConteudosItemTextosTexto>
							</ListaConteudosItemTextos>
						</ListaConteudosItem>

						{/* Item 2 */}
						<ListaConteudosItem>
							<ListaConteudosItemIndex>2</ListaConteudosItemIndex>
							<ListaConteudosItemTextos>
								<ListaConteudosItemTextosTitulo>Direcionamento estratégico</ListaConteudosItemTextosTitulo>
								<ListaConteudosItemTextosTexto>Você aprende a dar os primeiros passos e a estudar de forma direcionada, sabendo exatamente o que fazer.</ListaConteudosItemTextosTexto>
							</ListaConteudosItemTextos>
						</ListaConteudosItem>

						{/* Item 3 */}
						<ListaConteudosItem>
							<ListaConteudosItemIndex>3</ListaConteudosItemIndex>
							<ListaConteudosItemTextos>
								<ListaConteudosItemTextosTitulo>As melhores técnicas</ListaConteudosItemTextosTitulo>
								<ListaConteudosItemTextosTexto>Você estuda com as estratégias e técnicas que mais aprovam no Brasil.</ListaConteudosItemTextosTexto>
							</ListaConteudosItemTextos>
						</ListaConteudosItem>

					</ListaConteudos>

				</ColSm6>

			</ContainerInterno>
		</Container>
	)
}
